import { companyHttpClient } from "../../../installations/axiosInterfaces";

const getCompany = (companyId) => {
  return companyHttpClient.get(`Get/${companyId}`);
};

const companyService = {
  getCompany,
};

export default companyService;
